document.addEventListener('DOMContentLoaded', function () {
	console.log('frontend load');
});
